<form [formGroup]="formGroup">
  <div style="width: fit-content">
    <pdq-radio-group formControlName="type" labelSize="small" label="Type of date picker">
      @for (geoMethod of datePickerTypeConfig; track geoMethod) {
        <pdq-radio-button
          [value]="geoMethod.value"
          [checked]="geoMethod.checked(formGroup.value['type']) || geoMethod.defaultChecked"
          [text]="geoMethod.text">
        </pdq-radio-button>
      }
    </pdq-radio-group>
  </div>
</form>
